<template>
  <nav class="cart-navigation">
    <ul>
      <li v-if="accountIcon" class="desktop-only">
        <AccountIcon class="header-button" />
      </li>
      <li class="compare-navigation-item">
        <CompareIcon />
      </li>
      <li v-if="wishlistIcon" class="cart-navigation-item">
        <WishlistIcon />
      </li>
      <li v-if="cartIcon" class="cart-navigation-item">
        <CartIcon />
      </li>
    </ul>
  </nav>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api'
import CompareIcon from 'components/compare/CompareIcon.vue';

export default defineComponent({
  name: 'CartNavigation',
  components: {
    CompareIcon,
    WishlistIcon: () => import('components/wishlist/WishlistIcon'),
    AccountIcon: () => import('components/theme/Icons/AccountIcon.vue'),
    CartIcon: () => import('components/theme/Icons/CartIcon.vue')
  },
  props: {
    accountIcon: {
      type: Boolean,
      default: false
    },
    wishlistIcon: {
      type: Boolean,
      default: true
    },
    cartIcon: {
      type: Boolean,
      default: true
    }
  }
})
</script>
<style lang="scss">
@import 'styles/theme/components/Header/CartNavigation';
</style>